import { useEffect, useState } from "react";
import dailyFilterDefault from '@/pages/dashboard/filterPageComponents/overview/dailyFilterDefault';
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import { overviewMonthlyRequest } from "../../pages/overview/_config/overviewMonthlyRequest";

/**
 * 按照接口区分为不同model
 * hook名称规范：use+接口名称+Data
 * @param props 父页面所有props
 * @param props: timeZone 时区信息，realtime特有
 * @param props: dispatch dva  dispatch方法
 * @returns 
 * 获取数据的逻辑：dva中有数据则取dva中的数据，否则自己通过接口请求
 */

const useMonthlyKeyMetricsModel = (
  props: any, 
  formValue: any, 
  dispatch: any, 
  filterLoading: boolean,
  overviewMonthlyReqType = "normal"
) => {
  const { gameCode } = props;
  const formVal = formValue || dailyFilterDefault;
  const [componentData, setComponentData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  // 点击筛选器的时候
  useEffect(() => {
    if (!formValue) return;
    if (!filterLoading) {
      getMonthlyKeyMetricsDataFunc();
    }
  }, [formVal]);


  const getMonthlyKeyMetricsDataFunc = (isRefresh?: boolean) => {
    const {  filterValue } = formValue;
    const { rangeTime: [start, end], ...filters } = filterValue;
    const params = {
      game_code: gameCode,
      filters: formatFilterValues(filters),
      start_time: start,
      end_time: end,
    };
    setLoading(!isRefresh);
    overviewMonthlyRequest.getMonthlyKeyPerformanceMetrics[overviewMonthlyReqType](params).then((result: any) => {
      setError(false);
      setLoading(false);
      setComponentData(result);
      dispatch({
        type: "overview/getMonthlyKeyPerformanceMetrics",
        payload: {
          result
        }
      });
    }).catch(() => {
      setError(true);
      setLoading(false);
    });
  };
  return {
    // nodata 不在此封装，因为可能是接口的个别项目nodata
    componentData,
    loading,
    error,
  };
};

export default useMonthlyKeyMetricsModel;